import Backdraft from "../../Assets/BackDraft.png";
import GetOutlier from "../../Assets/GetOutlier.png";
import ComplyAI from "../../Assets/ComplyAI.png";
import DCM from "../../Assets/DCM.png";
import RestaurantRes from "../../Assets/RestaurantRes.png";
import WeLoveMovies from "../../Assets/WLM.png";

const Menu = [
  {
    id: 1,
    image: Backdraft,
    title: "Backdraft Suppressors",
    category: "Front-End Development",
    url: "https://backdraftsuppressors.com",
  },
  {
    id: 2,
    image: GetOutlier,
    title: "GetOutlier",
    category: "Full-Stack Development",
    url: "https://getoutlier.com/",
  },
  {
    id: 3,
    image: ComplyAI,
    title: "ComplyAI",
    category: "Full-Stack Development",
    url: "https://www.gocomply.ai/",
  },
  {
    id: 4,
    image: DCM,
    title: "Digital Cartel Media",
    category: "Front-End Development",
    url: "https://digitalcartelmedia.com/",
  },
  {
    id: 5,
    image: RestaurantRes,
    title: "Restaurant Reservation Application",
    category: "Full Stack Development",
    url: "https://restaurantresfinal.vercel.app/dashboard",
  },
  {
    id: 6,
    image: WeLoveMovies,
    title: "We Love Movies Database Project",
    category: "Back-End Development",
    url: "https://welovemoviesfrontend-nijt.onrender.com",
  },
];

export default Menu;
